import React, {useCallback, useState} from 'react';
import {ScenarioActionProps} from '../../../actionMenuTypes';
import {useDispatch} from 'react-redux';
import {useMounted} from '../../../../../hooks/useMounted';
import {scenarioStatusUpdate} from '../../../../../store/scenario';
import {ScenarioStatus} from 'hemwb-api';
import {trackInstanceCalibrationSuperseded} from '../../../../../tracking/tracking';
import CancelButton from '../../../../core/Buttons/CancelButton';
import {tid} from '../../../../../testUtils';
import {SUBMODEL_ACTION_MENU_IDS} from '../../../../../test/types';
import SubmitButton from '../../../../core/Buttons/SubmitButton';
import Block from '@mui/icons-material/Block';

const ScenarioSupersede: React.FC<ScenarioActionProps> = ({model, subModel, scenario, onSuccess, onCancel}) => {
  const dispatch = useDispatch();
  const mounted = useMounted();
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = useCallback(async () => {
    setSubmitting(true);
    try {
      await scenarioStatusUpdate(dispatch, scenario.id, ScenarioStatus.SUPERSEDED);
      trackInstanceCalibrationSuperseded(model, subModel, scenario);
      onSuccess?.();
    } catch (e) {
    } finally {
      mounted.current && setSubmitting(false);
    }
  }, [dispatch, mounted, model, subModel, scenario, onSuccess]);

  return (
    <>
      <h2>Supersede Instance</h2>
      <p>Are you sure you want to supersede this instance?</p>

      <div className="buttonsContainer">
        <br />
        <br />
        <CancelButton onClick={onCancel} {...tid(SUBMODEL_ACTION_MENU_IDS.SCENARIO_SUPERSEDE, 'cancel')} />
        <SubmitButton
          onClick={handleSubmit}
          active={submitting}
          endIcon={<Block />}
          {...tid(SUBMODEL_ACTION_MENU_IDS.SCENARIO_SUPERSEDE, 'submit')}
        >
          Supersede
        </SubmitButton>
      </div>
    </>
  );
};

export default ScenarioSupersede;
